import DOMPurify from 'dompurify';
import * as Configuration from "../Configuration/Configuration";
import * as Logging from "../Logging/Logging";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface TrustedScriptURL { }

interface TrustedTypePolicyFactory {
    createPolicy: (
        name: string,
        rules: {
            createScriptURL: (str: string) => TrustedScriptURL;
            createHTML: (str: string) => string;
        }
    ) => TrustedTypePolicy;
}

interface TrustedTypePolicy {
    createScriptURL: (str: string) => TrustedScriptURL;
    createHTML: (str: string) => string;
}

declare global {
    interface Window {
        trustedTypes: TrustedTypePolicyFactory;
    }
}

let ofbTrustedTypeInstance = undefined;

export const domUtilsTrustedTypePolicy = () => {
    if (!ofbTrustedTypeInstance) {
        ofbTrustedTypeInstance = window.trustedTypes?.createPolicy("officebrowserfeedback#domUtils", {
            createScriptURL: (scriptUrlString: string) => {
                // If it is an absolute URL, we need to check if it is from the same origin.
                if (scriptUrlString.indexOf("://") > 0 || scriptUrlString.indexOf("//") === 0) {
                    const scriptUrl = new URL(scriptUrlString);
                    if (scriptUrl?.protocol !== 'https:') {
                        throw new Error(`Only https protocol is allowed for script url ${scriptUrlString}`)
                    }

                    const trustedOrigins = Configuration.get().getCommonInitOptions().allowedDomains;
                    const currentOrigin = getUrlDomain(document.location.hostname);
                    const scriptOrigin = getUrlDomain(scriptUrl.origin);
                    if (scriptUrl.origin !== document.location.origin && !trustedOrigins.includes(scriptOrigin) && currentOrigin !== scriptOrigin) {
                        Logging.getLogger().logEvent(Logging.EventIds.TRUSTEDTYPES_URL_BLOCKED,
                            Logging.LogLevel.Critical,
                            {
                                Data: JSON.stringify({
                                    scriptUrl: scriptUrlString,
                                    currentHostname: document.location.hostname,
                                    currentOrigin: document.location.origin,
                                    scriptOrigin: scriptUrl.origin,
                                }),
                            });
                        return `about:blank#blocked`;
                    }
                    return scriptUrl.href;
                }

                // If it is a relative URL, we are sure it is from the same domain.
                return scriptUrlString;
            },
            createHTML: (htmlString: string) => { return sanitizeHtmlString(htmlString) },
        });
    }
    return ofbTrustedTypeInstance;
}

export function sanitizeHtmlString(htmlString: string) {
    return DOMPurify.sanitize(htmlString, { ADD_ATTR: ["focusable"] })
}

export function sanitizeOutputString(inputString: string) {
    return DOMPurify.sanitize(inputString, { USE_PROFILES: { html: true } })
}

const getUrlDomain = (url: string) => {
    return url.split('.').splice(-2).join('.');
}